<template>
  <div class="pushchannelmanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="createAtMY" label="创建时间" width="160"></el-table-column>

      <el-table-column prop="level" label="级别" width="65">
        <template slot-scope="scope">
          <div v-if="scope.row.level === 1">
            <el-tag>{{'信息'}}</el-tag>
          </div>

          <div v-if="scope.row.level === 3">
            <el-tag type="danger">{{'错误'}}</el-tag>
          </div>

          <div v-if="scope.row.level === 0">
            <el-tag type="info">{{'调试'}}</el-tag>
          </div>

          <div v-if="scope.row.level === 2">
            <el-tag type="warning">{{'警告'}}</el-tag>
          </div>
          
        </template>
      </el-table-column>
      <el-table-column label="日志分类" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.category +'-' + scope.row.action || '暂无信息'}}</span>
        </template>
      </el-table-column>

      <el-table-column label="日志内容">
        <template slot-scope="scope">
          <span class="tit" @click="rowClick(scope.row)" style="color: #5b9bd1;cursor: pointer;">{{scope.row.contentMY.message || '点击查看日志原文'}}</span>
        </template>
      </el-table-column>

    </el-table>


    <el-dialog
      :visible.sync="detailDialogVisible"
      width="30%"
      :before-close="handleClosedetail">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>日志内容</div>
      </div>
      <div>
        <div>{{this.picMsg.content}}</div>
        <br>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "pushchannelmanagetable",
  props: {
    tableData:Array,
  },
  data() {
    return {
      detailDialogVisible:false,
      picMsg:{}
      // tableData: [
        // {
        //   date: "2020-04-21",
        //   type: "公开需求",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // }
      // ]
    };
  },
  methods: {


    //表格行点击效果
    rowClick(row){
      this.picMsg = row
      this.detailDialogVisible = true
    },

    //图片邀约详情弹窗关闭事件
    handleClosedetail(){
      this.detailDialogVisible = false
    },







    closeClick(scope) {
      this.$emit("authClick", scope);
    },
    changeClick(scope) {
      this.$emit("changeClick", scope);
    },
    delectClick(scope) {
      this.$emit("delectClick", scope);
    },
    linkClick(scope) {
      // this.$emit('removeClick',scope)
      this.mydialogVisible = true;
    },
    quit() {
      this.mydialogVisible = false;
    },
    handleClose() {
      this.mydialogVisible = false;
    },

  },
  created() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table {
  width: auto;
}

.el-table /deep/ .cell .tit:hover{
  text-decoration: underline !important;
}
</style>
